import { apiClient } from "./client";

export interface SeedDataResponse {
  success: boolean;
  message: string;
  created: {
    relations: number;
    items: number;
    taxes: number;
    bankAccounts: number;
    projects: number;
    invoices: number;
    estimates: number;
    creditNotes: number;
    expenses: number;
    payments: number;
    worklogs: number;
    comments: number;
  };
  deleted?: {
    payments: number;
    worklogs: number;
    comments: number;
    lineItems: number;
    invoices: number;
    estimates: number;
    creditNotes: number;
    expenses: number;
    projects: number;
    bankAccounts: number;
    items: number;
    taxes: number;
    relations: number;
  };
}

/**
 * Generate seed data for the authenticated user's organization
 * @param clearExisting - Whether to delete existing data before seeding
 */
export const generateSeedData = async (clearExisting: boolean = false): Promise<SeedDataResponse> => {
  const response = await apiClient.post<SeedDataResponse>(
    "/api/seed",
    {},
    {
      params: { clearExisting: clearExisting.toString() },
      headers: { "Content-Type": "application/json" },
    },
  );
  return response.data;
};
